import './ServicesTechnologies.scss';
import '../../../../Sections/Map/Map'

ComponentManager.init(document.body);